import { Tooltip } from '@material-ui/core';
import React from 'react';
import { JSX } from 'react';

import {
  InventoryRuleResponseType,
  InventoryRuleTimezoneType,
  InventoryRuleType,
} from '~/src/dash/apiV2/inventory-rules/inventoryRules';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { ICustomRenderCellJSXProps } from '~/src/dash/components/tables/ListViewTable/common';
import { Text, TKey } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const RULE_TYPE_TRANSLATION_MAP: Record<InventoryRuleType, TKey> = {
  [InventoryRuleType.UNKNOWN]: 'Unknown',
  [InventoryRuleType.VMAP]: 'VMAP',
  [InventoryRuleType.VAST]: 'VAST',
  [InventoryRuleType.ORTB]: 'ORTB',
};

export const convertRuleTypeToTKey = (ruleType: number): TKey => {
  return RULE_TYPE_TRANSLATION_MAP[ruleType as InventoryRuleType] ?? 'Unknown';
};

export const RuleTypeOptions: ISelectOption[] = [
  // { id: InventoryRuleType.UNKNOWN, label: 'Unknown', tKey: 'Unknown' }, // FOR REFERENCE ONLY
  { id: InventoryRuleType.VMAP, label: 'VMAP', tKey: 'VMAP' },
  { id: InventoryRuleType.VAST, label: 'VAST', tKey: 'VAST' },
  { id: InventoryRuleType.ORTB, label: 'ORTB', tKey: 'ORTB' },
];

const RESPONSE_TYPE_TRANSLATION_MAP: Record<InventoryRuleResponseType, TKey> = {
  [InventoryRuleResponseType.UNKNOWN]: 'Unknown',
  [InventoryRuleResponseType.INLINE_VAST]: 'InlineVAST',
  [InventoryRuleResponseType.AD_TAG_URI]: 'AdTagURI',
};

export const convertResponseTypeToTKey = (responseType: number): TKey => {
  return RESPONSE_TYPE_TRANSLATION_MAP[responseType as InventoryRuleResponseType] ?? 'Unknown';
};

const TIMEZONE_TYPE_TRANSLATION_MAP: Record<InventoryRuleTimezoneType, TKey> = {
  [InventoryRuleTimezoneType.UNKNOWN]: 'Unknown',
  [InventoryRuleTimezoneType.VIEWER]: 'Viewer',
  [InventoryRuleTimezoneType.PUBLISHER]: 'Publisher',
};

export const TimezoneTypeOptions: ISelectOption[] = [
  // { id: InventoryRuleTimezoneType.UNKNOWN, label: 'Unknown', tKey: 'Unknown' }, // FOR REFERENCE ONLY
  { id: InventoryRuleTimezoneType.VIEWER, label: 'Viewer', tKey: 'Viewer' },
  { id: InventoryRuleTimezoneType.PUBLISHER, label: 'Publisher', tKey: 'Publisher' },
];

export const convertTimezoneTypeToTKey = (timezoneType: number): TKey => {
  return TIMEZONE_TYPE_TRANSLATION_MAP[timezoneType as InventoryRuleTimezoneType] ?? 'Unknown';
};

export const InventoryRuleNameWithDefault = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { value } = props;
  const isUnnamed = value === '' || value === undefined;

  return (
    <Tooltip title={value} placement='top-start'>
      <div>
        {isUnnamed ? (
          <Text
            small
            bold
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              color: publicaColors.mediumGray,
            }}
            tKey='UnnamedRule'
          />
        ) : (
          <Text
            small
            bold
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {value}
          </Text>
        )}
      </div>
    </Tooltip>
  );
};
